import React from "react";
import ReactDOM from "react-dom/client";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { BrowserRouter } from 'react-router-dom';
import Feature from './feature-module/feature';
import 'aos/dist/aos.css';
import { Provider } from 'react-redux';
import store from './core/data/redux/store';
import '../src/style/scss/main.scss'
import '../src/style/css/feather.css'
import './index.scss';
import "./feature-module/auth/style.scss";
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { base_path } from "./environment";
import "./utils/socket-client";

import { startNotificationSocket } from "./services/notificationSocket.service";

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("Element with id 'root' not found.");
  throw new Error("Root element missing");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename={base_path}>
      <Feature />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

/* --------------------------------------------------------------
   START WEBSOCKET ONCE (after first render & when user is logged in)
   -------------------------------------------------------------- */
let socketStarted = false;

const tryStartSocket = () => {
  if (socketStarted) return;

  const isLoggedIn = store.getState().user?.isLogin === true;
  if (isLoggedIn) {
    console.log("User logged in → Starting WebSocket");
    startNotificationSocket();
    socketStarted = true;
    // No longer need to listen
    unsubscribe();
  }
};

// Subscribe to store changes (login may happen later)
const unsubscribe = store.subscribe(tryStartSocket);

// Also check immediately (page refresh with token)
tryStartSocket();